var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 74.3125,
    stroke: "#D1D5DA",
    strokeOpacity: 0.3,
    strokeWidth: 11.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.547 27.4531C146.483 41.3894 154.312 60.2911 154.312 80C154.313 99.7089 146.483 118.611 132.547 132.547",
    stroke: "currentColor",
    strokeWidth: 11.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.95a53788f7ca910f7b998296bdc748c7.svg";
export { ForwardRef as ReactComponent };